<ion-header>
  <ion-toolbar>
    <ion-title>Request event</ion-title>

    <ion-button slot="end" (click)="close()"fill="clear">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form">
    <ion-list>
      <ion-item>
        <ion-input label="Your name" labelPlacement="floating" type="text" formControlName="name"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="Your email" labelPlacement="floating" type="text" formControlName="email"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="Your sport" labelPlacement="floating" type="text" formControlName="discipline"></ion-input>
      </ion-item>

      <ion-item>
        <ion-input label="Event name" labelPlacement="floating" type="text" formControlName="eventName"></ion-input>
      </ion-item>

      <ion-item>
          <ion-select label="Event type" labelPlacement="floating" formControlName="eventType" interface="popover">
            <ion-select-option value="INDIVIDUAL">Singles / Doubles</ion-select-option>
            <ion-select-option value="TEAM">Team</ion-select-option>
          </ion-select>
      </ion-item>

      <ion-item>
        <ion-label>Start date</ion-label>
        <ion-datetime-button datetime="date"></ion-datetime-button>
      </ion-item>

      <ion-item>
        <ion-textarea label="Tell us about your event" rows="5" labelPlacement="floating" type="text" formControlName="description" placeholder="Please provide details about your location, organization, number of players/teams and whether you're using video streaming, scoreboards, chair officials, or other needs."></ion-textarea>
      </ion-item>
    </ion-list>

    <ion-button class="ion-margin" (click)="submit()" expand="block">
      Submit
    </ion-button>

    <ion-modal [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime formControlName="startDate" id="date" presentation="date"></ion-datetime>
      </ng-template>
    </ion-modal>
  </form>
</ion-content>